import styled from 'styled-components';

export const StyledLandingPage = styled.section`
	.hero-section {
		padding: 0 50px 150px;

		@media (max-width: 860px) {
			padding: 0 20px 115px;
		}

		header {
			height: fit-content;
			margin-bottom: 50px;

			@media (max-width: 1200px) {
				margin-bottom: 90px;
			}

			@media (max-width: 860px) {
				margin-bottom: 30px;
			}

			.nav-wrapper {
				max-width: 1580px;
				margin: 0 auto;
				padding: 25px 0;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.logo a {
					display: flex;
				}

				nav {
					display: flex;
					align-items: center;
					gap: 58px;
					font-size: 16px;

					@media (max-width: 1200px) {
						gap: 40px;
					}

					@media (max-width: 860px) {
						flex-direction: column;
						justify-content: center;
						background-color: #fff;
						position: fixed;
						top: 0;
						bottom: 0;
						left: 0;
						right: 0;
						z-index: -1;
						opacity: 0;
						transition: 0.2s;

						&.show {
							z-index: 100;
							opacity: 1;
							a {
								color: black !important;
							}

							.try-now {
								color: black !important;
								background-color: rgb(238, 238, 238) !important;
							}
						}
					}

					.try-now {
						padding: 11px 17px 9px 17px;
						border-radius: 5px;
						display: flex;
						align-items: center;
						justify-content: center;

						transition: 0.2s;

						&:hover {
							opacity: 0.75;
						}
					}
				}

				.hamburger {
					display: none;
					font-size: 22px;
					cursor: pointer;

					@media (max-width: 860px) {
						display: block;
					}
				}

				.close {
					display: none;
					color: black;
					@media (max-width: 860px) {
						display: none;
						font-size: 30px;
						cursor: pointer;
						position: fixed;
						right: 20px;
						top: 20px;
						z-index: 101;

						&.show {
							display: block;
						}
					}
				}
			}
		}

		.hero-content-container {
			max-width: 1420px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			gap: 100px;

			@media (max-width: 1440px) {
				gap: 50px;
			}

			@media (max-width: 1200px) {
				flex-direction: column;
				align-items: center;
			}

			.details-wrapper {
				padding-top: 100px;
				display: flex;
				flex-direction: column;
				gap: 0px;

				@media (max-width: 1200px) {
					padding-top: 0;
				}

				h1 {
					font-size: 48px;

					@media (max-width: 860px) {
						font-size: 36px;
					}
				}

				h3 {
					font-size: 38px;
					margin-bottom: 35px;
					margin-top: 20px;

					@media (max-width: 860px) {
						font-size: 32px;
					}
				}

				.teaser {
					font-size: 22px;
					line-height: 1.5;
					width: 90%;

					@media (max-width: 860px) {
						font-size: 18px;
					}
				}

				a {
					margin-top: 20px;
					border: none;
					background-color: transparent;
					padding: 15px 25px 13px 25px;
					border-radius: 5px;
					font-weight: 600;
					font-size: 22px;
					width: fit-content;
					cursor: pointer;
					transition: 0.2s;

					&:hover {
						opacity: 0.75;
					}

					@media (max-width: 860px) {
						font-size: 18px;
					}
				}
			}

			img {
				width: 600px;
				height: 700px;
				// max-width: 600px;
				// max-height: 700px;
				// width: auto;
				// height: auto;
				margin-bottom: -260px;
				object-fit: cover;
				border-radius: 5px;

				@media (max-width: 1200px) {
					height: fit-content;
					max-width: 700px;
					width: 100%;
				}

				@media (max-width: 1100px) {
					margin-bottom: -215px;
				}
			}
		}
	}

	.features-section {
		padding: 235px 50px 150px;

		@media (max-width: 1200px) {
			padding: 205px 50px 120px;
		}

		@media (max-width: 860px) {
			padding: 175px 20px 120px;
		}

		.features-content-wrapper {
			max-width: 1420px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			gap: 150px;

			@media (max-width: 1440px) {
				gap: 100px;
			}

			.feature {
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 120px;

				@media (max-width: 1440px) {
					gap: 50px;
				}

				@media (max-width: 1200px) {
					flex-direction: column-reverse;
					align-items: center;
				}

				&:nth-child(even) {
					flex-direction: row-reverse;

					@media (max-width: 1200px) {
						flex-direction: column-reverse;
						align-items: center;
					}
				}

				.feature-details {
					h2 {
						font-size: 38px;
						margin-bottom: 20px;

						@media (max-width: 860px) {
							font-size: 32px;
						}
					}

					p {
						font-size: 18px;
						line-height: 1.5;

						@media (max-width: 860px) {
							font-size: 16px;
						}
					}
				}

				img {
					max-width: 640px;
					max-height: 374px;
					min-height: 374px;
					object-fit: cover;
					border-radius: 5px;

					@media (max-width: 1200px) {
						height: fit-content;
						max-width: unset;
						min-height: fit-content;
						max-width: 100%;
					}
				}
			}
		}
	}

	.benefits-section {
		padding: 150px 50px;

		@media (max-width: 1200px) {
			padding: 130px 50px;
		}

		@media (max-width: 860px) {
			padding: 100px 20px;
		}

		.benefits-content-wrapper {
			max-width: 1420px;
			margin: 0 auto;

			h3 {
				font-size: 38px;
				margin-bottom: 20px;
				text-align: center;

				@media (max-width: 860px) {
					font-size: 32px;
				}
			}

			p {
				text-align: center;
				font-size: 22px;
				line-height: 1.5;
				max-width: 660px;
				margin: 0 auto;

				@media (max-width: 860px) {
					font-size: 18px;
				}
			}

			.benefit-cards {
				margin-top: 100px;
				display: flex;
				justify-content: center;
				gap: 50px;
				align-items: stretch;
				flex-wrap: wrap;

				@media (max-width: 1440px) {
					margin-top: 50px;
				}

				.card {
					padding: 50px 32px;
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					gap: 20px;
					border-radius: 10px;
					width: 400px;
					flex: 350px;

					h4 {
						font-size: 20px;
						text-align: left;

						@media (max-width: 860px) {
							font-size: 18px;
						}
					}

					p {
						font-size: 18px;
						line-height: 1.5;
						text-align: left;
						margin: 0;

						@media (max-width: 860px) {
							font-size: 16px;
						}
					}

					a {
						font-weight: 500;
						font-size: 22px;
						cursor: pointer;
						padding: 15px 25px 13px;
						border: none;
						background-color: transparent;
						margin: 0 auto;
						border-radius: 5px;

						@media (max-width: 860px) {
							font-size: 16px;
						}
					}
				}
			}
		}
	}

	.examples-section {
		padding: 150px 50px;

		@media (max-width: 1200px) {
			padding: 130px 50px;
		}

		@media (max-width: 860px) {
			padding: 100px 20px;
		}

		.examples-content-wrapper {
			max-width: 1420px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			gap: 150px;

			@media (max-width: 1440px) {
				gap: 100px;
			}

			.example {
				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 120px;

				@media (max-width: 1440px) {
					gap: 50px;
				}

				@media (max-width: 1200px) {
					flex-direction: column-reverse;
					align-items: center;
				}

				&.ltr {
					flex-direction: row-reverse;

					@media (max-width: 1200px) {
						flex-direction: column-reverse;
						align-items: center;
					}
				}

				&.top-to-bottom {
					flex-direction: column-reverse;
					gap: 50px;
					text-align: center;

					p{
						max-width: 930px;
					}

					@media (max-width: 1200px) {
						text-align: left;
					}

					img,
					.html {
						width: 100%;
						border-radius: 5px;
						min-height: unset;
						max-width: 930px;
						height: 100%;
					}
				}

				.example-details {
					h2 {
						font-size: 38px;
						margin-bottom: 20px;

						@media (max-width: 860px) {
							font-size: 32px;
						}
					}

					p {
						font-size: 18px;
						line-height: 1.5;

						@media (max-width: 860px) {
							font-size: 16px;
						}
					}
				}

				img,
				.html {
					min-width: 600px;
					min-height: 450px;
					object-fit: cover;
					border-radius: 5px;

					@media (max-width: 1200px) {
						height: fit-content;
						min-width: unset;
						max-width: unset;
						min-height: fit-content;
						width: 100%;
					}
				}
			}
		}
	}

	.reviews-widget {
		padding-top: 100px;
		margin: 0;
		background: #fff;

		h3 {
			margin-bottom: 100px;
		}
	}
`;
